module.exports = __webpack_public_path__ + "images/category_lp/common/icon-voice-man-50@2x_9481f9c502b5999046ba2becc3433b04.png";